import Toaster from "../utils/classes/Toaster";

export default function (el) {
    const text = el.dataset && el.dataset.text ? el.dataset.text : null;

    const handleClick = () => {
        const toast = Toaster.createToast("text-copy", "URL copied to clipboard");
        Toaster.addToast(toast);
        navigator.clipboard.writeText(text);
    };

    if (!text) return;

    el.addEventListener("click", handleClick);
}
